import { Component } from '@angular/core';

@Component({
	selector: 'app-cobrand-logos',
	templateUrl: './cobrand-logos.component.html',
	styleUrl: './cobrand-logos.component.scss',
})
export class CobrandLogosComponent {}
